"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const custom_element_decorators_1 = require("../../lib/custom-element-decorators");
const html_custom_element_1 = require("../../lib/html-custom-element");
const reactive_decorators_1 = require("../../lib/reactive-decorators");
exports.createImagePropertiesDialogTabComponent = () => {
    class Component2 extends html_custom_element_1.HTMLCustomElement {
    }
    __decorate([
        reactive_decorators_1.StringAttribute('name'),
        __metadata("design:type", String)
    ], Component2.prototype, "name", void 0);
    __decorate([
        reactive_decorators_1.StringAttribute('label'),
        __metadata("design:type", String)
    ], Component2.prototype, "label", void 0);
    __decorate([
        reactive_decorators_1.BooleanAttribute('show-visibility-options'),
        __metadata("design:type", Boolean)
    ], Component2.prototype, "showVisibilityOptions", void 0);
    __decorate([
        reactive_decorators_1.BooleanAttribute('readonly-dimension-fields'),
        __metadata("design:type", Boolean)
    ], Component2.prototype, "readonlyDimensionFields", void 0);
    __decorate([
        reactive_decorators_1.ViewChildren('[vce-ipd-warning]'),
        __metadata("design:type", Array)
    ], Component2.prototype, "warningStrategies", void 0);
    return Component2;
};
custom_element_decorators_1.CustomElement('vce-image-properties-dialog-tab')(exports.createImagePropertiesDialogTabComponent());
//# sourceMappingURL=image-properties-dialog-tab.component.js.map